import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MessageComponent } from 'src/app/message/message.component';
import { PaymentService } from 'src/app/service/payment.service';

@Component({
  selector: 'app-payment-refund',
  templateUrl: './payment-refund.component.html',
  styleUrls: ['./payment-refund.component.scss']
})
export class PaymentRefundComponent implements OnInit {
studentDetail:any;
refundForm = new FormGroup<any>({
  studentName:new FormControl<any>('',[Validators.required]),
  studentId:new FormControl<any>('',[Validators.required]),
  refundAmt:new FormControl<any>('',[Validators.required]),
  payeeName:new FormControl<any>(''),
  grade:new FormControl<any>('',[Validators.required]),
  section:new FormControl<any>('',[Validators.required]),
  Iban:new FormControl<any>(''),
  accName:new FormControl<any>(''),
  reason:new FormControl<any>('',[Validators.required])
})
isCheque:boolean=true;
isBank:boolean=false
count: any=0;
minDescErr: boolean=true;
excessAmt:any;
  digopen: any;
  referenceNumber:any;
  constructor(public paymentService:PaymentService,private dialog: MatDialog, private router:Router) { }

  ngOnInit(): void {
    this.setValidations();
    this.paymentService.excessAmt.subscribe(res=>{
    this.excessAmt=res;
    })
    let transportInfo =JSON.parse(localStorage.getItem("transportChildInfo"));
    let selectedStudent =localStorage.getItem("selectedstudentid")
    let detail = transportInfo.find(x=>x.studentNo == selectedStudent)
    let grade = detail?.grade.split("/");
   //detail.section=section[1];
    this.studentDetail=detail
    this.refundForm.patchValue({
      "studentName":this.studentDetail?.studentName,
      "studentId":this.studentDetail?.stU_SCHOOL_ID,
      "grade":grade[0],
      "section":this.studentDetail?.section
    })
  }

  onChangeRadio(isCheque:any,isBank:any)
  {
    this.isCheque=isCheque.checked;
    this.isBank=isBank.checked;
    this.refundForm.patchValue({
      payeeName:'',
      Iban:'',
      accName:''
    })
     this.setValidations();
  }

  setValidations()
  {
    if(this.isCheque)
    {
    this.refundForm.controls.payeeName.setValidators([Validators.required]);
    this.refundForm.controls.Iban.markAsUntouched();
    this.refundForm.controls.accName.markAsUntouched();
    this.refundForm.controls.Iban.clearValidators();
    this.refundForm.controls.Iban.updateValueAndValidity();
    this.refundForm.controls.accName.clearValidators();
    this.refundForm.controls.accName.updateValueAndValidity();
    }
    else{
      this.refundForm.controls.payeeName.markAsUntouched();
      this.refundForm.controls.payeeName.clearValidators();
      this.refundForm.controls.payeeName.updateValueAndValidity();
      this.refundForm.controls.Iban.setValidators([Validators.required]);
      this.refundForm.controls.accName.setValidators([Validators.required]);
    }
  }
  onDescChange()
  {
    if(this.refundForm.get('reason').value && this.refundForm.get('reason').value.trim() != "")
    {
      this.count=this.refundForm.get('reason').value.length;
      if(this.count <=9)
       this.minDescErr=true;
       else this.minDescErr=false;
    }
    else{
      this.count=0;
      this.minDescErr=false;
      this.refundForm.patchValue({ "reason":this.refundForm.get('reason').value?.trim() == "" ? "" : this.refundForm.get('reason').value})
    }
  }

  submit(template:any)
  {
    let payload={
      "studentno":this.studentDetail?.studentNo,
      "RequestAmount":this.refundForm.get('refundAmt').value,
      "TransferMode":this.isBank?"bank":"cheqe",
      "PayeeName":this.isBank ? null :this.refundForm.get('payeeName').value,
      "IBANNumber":this.isBank ? this.refundForm.get('Iban').value :null,
      "AccountName":this.isBank ? this.refundForm.get('accName').value :'',
      "RequestReason":this.refundForm.get('reason').value
    }
    this.paymentService.saveRefund(payload).subscribe((res:any)=>{
      if(res?.success == "true")
      {
        this.referenceNumber=res?.data
        if(this.referenceNumber != "0")
      this.successDialog(template)
      else   this.openMessageDialog("Request already exist and not approved.", true, "");
      }
    })
  }
  openMessageDialog(msg: string, iseror: boolean, errormessage: string): void {
  
    const dialogRef = this.dialog.open(MessageComponent, {
      width: '500px',
      panelClass: 'custom-modalbox',
      data: {
        msg: msg,
        isError: iseror,
        errmessage: errormessage
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.cancel();
    });
  }
cancel()
{
  this.digopen?.close();
  this.router.navigate(['/statement-of-accounts'], { queryParams: { id: this.studentDetail?.studentNo } });
}

charOnly(event: any): boolean {
  const charCode = (event.which) ? event.which : event.keyCode;
  if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123)) {
    return true;
  }
  return false;
}

  successDialog(templateRef: TemplateRef<any>) {
    this.digopen = this.dialog.open(templateRef, {
      width: '550px',
      panelClass: 'custom-modalbox'
    });
  }

  ibanCharOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || (charCode >= 48 && charCode <= 57) || charCode === 32) {
      return true;
    }
    return false;
  }
}
